import api from './api';

export const bookService = {
  // Get all books with optional search and filters
  async getBooks(params = {}) {
    const response = await api.get('/books/', { params });
    return response.data;
  },

  async getBookCount(params = {}) {
    const response = await api.get('/books/count', { params });
    return response.data;
  },

  async getGenres() {
    const response = await api.get('/books/genres');
    return response.data;
  },

  // Get the featured book of the day
  async getFeaturedBook() {
    const response = await api.get('/books/featured');
    return response.data;
  },

  // Get a specific book by ID
  async getBook(bookId) {
    const response = await api.get(`/books/${bookId}`);
    return response.data;
  },

  // Get recommended books for a book
  async getRelatedBooks(bookId, limit = 6) {
    const response = await api.get(`/books/${bookId}/related`, { params: { limit } });
    return response.data;
  },

  // Create a new book (admin only)
  async createBook(bookData) {
    const response = await api.post('/books/', bookData);
    return response.data;
  },

  // Update a book (admin only)
  async updateBook(bookId, bookData) {
    const response = await api.put(`/books/${bookId}`, bookData);
    return response.data;
  },

  // Delete a book (admin only)
  async deleteBook(bookId) {
    const response = await api.delete(`/books/${bookId}`);
    return response.data;
  },

  // Import books from CSV (admin only)
  async importBooksCSV(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/books/import-csv', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};